<template>
	<div>
		<template v-if="headerShow">
		<div class="society">
			<div class="societyTil">
				{{type==1?$t('应届生岗位'):$t('全部职位')}}
			</div>
			<div class="societyAll">
				<div class="societyAllLeft">
					{{$t('共')}}（{{$t('个')}}{{allNum}}{{$t('已选')}}）
				</div>
				<div class="societyAllRight">
					<div>{{$t('条件')}} {{function_type.length+city_id.length+(keywords?1:0)}} {{$t('结果')}} | {{allNum}} {{$t('清除')}} | <span @click="goClear" style="cursor: pointer;">{{$t('输入职位关键字')}}</span></div>
					<div>
						<span @click="goClear" style="cursor: pointer;"><i class="el-icon-circle-close"></i></span>
					</div>
				</div>
			</div>
			<div class="societySs">
				<div class="societySsOne">
					<input v-model="keywords" :placeholder="$t('搜索职位')" />
				</div>
				<div class="societySsTwo" @click="goSs">{{$t('请选择')}}</div>
			</div>
			<div class="societyXl">
				<div class="societyXlOne">
					<el-select v-model="function_type" multiple :placeholder="$t('请选择')" @change="goSs">
						<el-option v-for="item in funList" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</div>
				<div class="societyXlTwo">
					<el-select v-model="city_id" :placeholder="$t('急')" multiple @change="goSs">
						<el-option v-for="item in cityList" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</div>
			</div>
			<div class="societyList">
				<div class="societyListFor" v-for="(item,index) in campusList" :key="index" @click="goDetail(item)">
					<div class="societyListForTop">
						<div class="societyListForTopOne">
							<div class="societyListForOne">
								<div class="jiBox" v-if="item.is_urgent==1">
									<span  class="ji">{{$t('投 递')}}</span>
								</div>
							{{item.name}}
							</div>
							<div class="societyListForTwo">{{item.city_name}}｜{{item.function_type_name}}｜{{item.create_time}}{{item.is_my==1?' | 面议':' | '+(item.min_salary||'--')+'~'+(item.max_salary||'--')+'*'+(item.work_month||'--')}}{{item.education?" | "+item.education:''}}</div>
						</div>
						<div class="societyListForTopTwo">
							<!-- <i class="el-icon-caret-bottom"></i> -->
							<i class="el-icon-caret-top" v-if="item.show"></i>
							<i class="el-icon-caret-bottom" v-else></i>
						</div>
					</div>
					<div class="societyListForThree" v-if="item.show">
						<div class="societyListForThreeOne">
							{{item.operating_duty}}
							<!-- 1.统招本科及以上学历,优秀的英语听说读写能力,会西语、葡语、俄语优先;<br/>
							2.3年以上医疗器械行业国际销售经验<br/>
							3.有亚洲中东非洲拉美区域销售经验优先<br/>
							4.有3年以上软镜国际售后经验,愿意转国际销售的人选亦可<br/>
							5.能承受较大工作压力,可适应国际出差。 -->
						</div>
						<div class="societyListForThreeTwo" @click.stop="goDetailTwo(item)">
							<div>{{$t('首页')}}</div>
						</div>
					</div>
				</div>
			</div>
			<div class="newsPagination ">
				<el-pagination :page-size="limit"  layout="prev, pager, next" :total="allNum" @current-change="goPagin">
				</el-pagination>
				<!-- <div class="newsPaginationFor" v-for="(item,index) in allArr" :key="index" @click="goPagin(item)">
					<div class="newsPaginationForOne" :class="page==item?'newsPaginationThree':'newsPaginationOne'"
						v-if="index==0">
						{{$t('尾页')}}
					</div>
					<div class="newsPaginationForOne" :class="page==item?'newsPaginationThree':'newsPaginationOne'"
						v-else-if="index==(allArr - 1)">
						{{$t('售前咨询')}}
					</div>
					<div class="newsPaginationForOne" :class="page==item?'newsPaginationFour':'newsPaginationTwo'"
						v-else>
						{{item}}
					</div>
				</div> -->
			</div>
			<!-- <div class="zxzw">
				<div class="zxzwTil">最新职位</div>
				<div class="zxzwList">
					<div class="zxzwListFor" v-for="(item,index) in 10" :key="index">设备工程师</div>
				</div>
			</div>
			<div class="societyTilTwo">
				HR联系方式
			</div>
			<div class="societyTilTwoCen">
				HR联系邮箱：hr@aohua.com
			</div> -->
		</div>
	</template>
		<template v-else>

			<div class="society">
			<div class="societyTil">
				{{type==1?$t('售后服务'):$t('合作咨询')}}
			</div>
			<div class="societyAll">
				<div class="societyAllLeft">
					{{$t('澳华内镜 总部')}}（{{$t('地址')}}{{allNum}}{{$t('电话')}}）
				</div>
				<div class="societyAllRight">
					<!-- <div>{{$t('品牌合作')}} {{function_type.length+city_id.length+(keywords?1:0)}} {{$t('市场')}} | {{allNum}} {{$t('服务优势')}} | <span @click="goClear" style="cursor: pointer;">{{$t('常见反馈')}}</span></div>
					<div>
						<span @click="goClear" style="cursor: pointer;"><i class="el-icon-circle-close"></i></span>
					</div> -->
					<div class="societyAllRightInfo">
							<div>{{$t('国内服务网点')}} {{function_type.length+city_id.length+(keywords?1:0)}} {{$t('地址')}} | {{allNum}} {{$t('电话')}} |  </div>
							<div @click="goClear" style="cursor: pointer;" class="clearBtn">
								{{$t('国际服务网点')}}
								<div>
									<span @click="goClear" style="cursor: pointer;"><i
											class="el-icon-circle-close"></i></span>
								</div>
							</div>
						</div>
				</div>
			</div>
			<div class="societySs">
				<div class="societySsOne">
					<input v-model="keywords" :placeholder="$t('地址')" />
				</div>
				<div class="societySsTwo" @click="goSs">{{$t('电话')}}</div>
			</div>
			<div class="societyXl">
				<div class="societyXlOne">
					<el-select v-model="function_type" multiple :placeholder="$t('国内售后')" @change="goSs">
						<el-option v-for="item in funList" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</div>
				<div class="societyXlTwo">
					<el-select v-model="city_id" :placeholder="$t('国际售后')" multiple @change="goSs">
						<el-option v-for="item in cityList" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</div>
			</div>
			<div class="societyList">
				<div class="societyListFor" v-for="(item,index) in campusList" :key="index" @click="goDetail(item)">
					<div class="societyListForTop">
						<div class="societyListForTopOne">
							<div class="societyListForOne">
								<div class="jiBox" v-if="item.is_urgent==1">
									<span  class="ji">{{$t('售后热线')}}</span>
								</div>
							{{item.name}}
							</div>
							<div class="societyListForTwo">{{item.city_name}}｜{{item.function_type_name}}｜{{item.create_time}}{{item.is_my==1?' | 面议':' | '+(item.min_salary||'--')+'~'+(item.max_salary||'--')+'*'+(item.work_month||'--')}}{{item.education?" | "+item.education:''}}</div>
						</div>
						<div class="societyListForTopTwo">
							<!-- <i class="el-icon-caret-bottom"></i> -->
							<i class="el-icon-caret-top" v-if="item.show"></i>
							<i class="el-icon-caret-bottom" v-else></i>
						</div>
					</div>
					<div class="societyListForThree" v-if="item.show">
						<div class="societyListForThreeOne">
							{{item.operating_duty}}
							<!-- 1.统招本科及以上学历,优秀的英语听说读写能力,会西语、葡语、俄语优先;<br/>
							2.3年以上医疗器械行业国际销售经验<br/>
							3.有亚洲中东非洲拉美区域销售经验优先<br/>
							4.有3年以上软镜国际售后经验,愿意转国际销售的人选亦可<br/>
							5.能承受较大工作压力,可适应国际出差。 -->
						</div>
						<div class="societyListForThreeTwo" @click.stop="goDetailTwo(item)">
							<div>{{$t('国内服务网点')}}</div>
						</div>
					</div>
				</div>
			</div>
			<div class="newsPagination ">
				<el-pagination :page-size="limit"  layout="prev, pager, next" :total="allNum" @current-change="goPagin">
				</el-pagination>
				<!-- <div class="newsPaginationFor" v-for="(item,index) in allArr" :key="index" @click="goPagin(item)">
					<div class="newsPaginationForOne" :class="page==item?'newsPaginationThree':'newsPaginationOne'"
						v-if="index==0">
						{{$t('地址')}}
					</div>
					<div class="newsPaginationForOne" :class="page==item?'newsPaginationThree':'newsPaginationOne'"
						v-else-if="index==(allArr - 1)">
						{{$t('电话')}}
					</div>
					<div class="newsPaginationForOne" :class="page==item?'newsPaginationFour':'newsPaginationTwo'"
						v-else>
						{{item}}
					</div>
				</div> -->
			</div>
			<!-- <div class="zxzw">
				<div class="zxzwTil">最新职位</div>
				<div class="zxzwList">
					<div class="zxzwListFor" v-for="(item,index) in 10" :key="index">设备工程师</div>
				</div>
			</div>
			<div class="societyTilTwo">
				HR联系方式
			</div>
			<div class="societyTilTwoCen">
				HR联系邮箱：hr@aohua.com
			</div> -->
		</div>
		</template>


	</div>
</template>

<script>
	import {
		get_recruit_list,
		get_function_type,
		get_city
	} from "@/api/recruit.js"
	import {
		get_config
	} from "@/api/config.js"
	export default {
		components: {

		},
		data() {
			return {
				options: [{
					value: '选项1',
					label: '黄金糕'
				}, {
					value: '选项2',
					label: '双皮奶'
				}, {
					value: '选项3',
					label: '蚵仔煎'
				}, {
					value: '选项4',
					label: '龙须面'
				}, {
					value: '选项5',
					label: '北京烤鸭'
				}],
				value1: '',
				value: '',
				allNum: 0,
				limit: 10,
				page: 1,
				campusList:[
					// {
					// 	name:'设备工程师',
					// 	cen:'上海-闵行｜研发｜2023-02-20',
					// 	show:true
					// },
					// {
					// 	name:'设备工程师',
					// 	cen:'上海-闵行｜研发｜2023-02-20',
					// 	show:false
					// },
					// {
					// 	name:'设备工程师',
					// 	cen:'上海-闵行｜研发｜2023-02-20',
					// 	show:false
					// },
					// {
					// 	name:'设备工程师',
					// 	cen:'上海-闵行｜研发｜2023-02-20',
					// 	show:false
					// },
				],
				type:1,
				keywords:'',
				function_type:[], 
				city_id:[],
				cityList:[],
				funList:[]
			}
		},
		computed: {
			allArr() {
				return Math.ceil(this.allNum / this.limit);
			}
		},
		mounted() {
			this.type=this.$route.query.type||1;
			console.log(this.type)
			this.getList();
			this.getFunType();
			this.getCity();
		},
		methods: {
			goClear(){
				this.page = 1;
				this.keywords='';
				this.function_type=[];
				this.city_id=[]
				this.getList();
			},
			goSs(){
				this.page = 1;
				console.log(this.function_type)
				this.getList();
			},
			goPagin(e) {
				this.page = e;
				this.getList();
			},
			goPagin(e) {
				this.page = e;
			},
			goDetail(item){
				console.log(item)
				item.show=!item.show;
				
			},
			getList(){
				let type=Number(this.type)+1;
				let data={
					page:this.page,
					limit:this.limit,
					type:type,
					keywords:this.keywords, 
					function_type:this.function_type, 
					city_id:this.city_id
				}
				get_recruit_list(data).then(res=>{
					console.log(res)
					let list=res.data.list;
					list.forEach(v=>{
						v.show=true
					})
					this.$nextTick(function(){
						this.campusList=list;
					})
					this.allNum=res.data.count
				}).catch(err=>{
					console.log(err)
				})
			},
			// 获取HR联系方式
			getEmail(){
				let data={}
				get_config(data).then(res=>{
					console.log(res)
					this.email=res.data.hr_contact_email
				}).catch(err=>{
					console.log(err)
				})
			},
			// 获取职能类型
			getFunType(){
				let data={
					type:1
				}
				get_function_type(data).then(res=>{
					console.log(res)
					this.funList=res.data.list;
				}).catch(err=>{
					console.log(err)
				})
			},
			// 获取城市
			getCity(){
				let data={
					type:1
				}
				get_city(data).then(res=>{
					console.log(res)
					this.cityList=res.data.list;
				}).catch(err=>{
					console.log(err)
				})
			},
			goDetailTwo(item){
				this.$router.push({
					push:'/recruitSocietyDetail',
					name:'recruitSocietyDetail',
					query: { id:item.id}
				})
			}
		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.newsPagination {
		display: flex;
		justify-content: center;
		align-items: center;
		padding-bottom: 160px;
		padding-top: 50px;
		width: 1200px;
		margin: 0 auto;

		.newsPaginationFor:not(:last-child) {
			margin-right: 54px;
		}

		.newsPaginationFor {
			.newsPaginationForOne {
				border-radius: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
				
				font-weight: 400;
				cursor: pointer;
			}

			.newsPaginationOne {
				background-color: #f4f4f4;
				width: 50px;
				height: 50px;
				font-size: 20px;
				color: #ACACAC;
			}

			.newsPaginationTwo {
				width: 20px;
				height: 20px;
				background-color: #f4f4f4;
				font-size: 17px;
				
				font-weight: 400;
				color: #ACACAC;
			}

			.newsPaginationThree {
				width: 50px;
				height: 50px;
				background-color: #848484;
				font-size: 20px;
				color: #FFFFFF;
			}

			.newsPaginationFour {
				width: 20px;
				height: 20px;
				background-color: #848484;
				font-size: 17px;
				
				font-weight: 400;
				color: #fff;
			}
		}
	}

	.society {
		width: 1000px;
		margin: 0 auto;
		padding-right: 200px;
		position: relative;

		.zxzw {
			position: absolute;
			top: 300px;
			right: -100px;
			width: 200px;
			padding: 21px 26px;
			background: #FFFFFF;
			box-shadow: 0px 1px 8px 0px rgba(39, 39, 39, 0.2);
			border-radius: 10px;

			.zxzwTil {
				font-size: 18px;
				
				font-weight: 400;
				color: #000000;
				margin-bottom: 22px;

			}

			.zxzwList {
				.zxzwListFor {
					margin-bottom: 16px;
					font-size: 18px;
					
					font-weight: 400;
					color: #000000;
				}
			}
		}

		.societyTil {
			padding-top: 82px;
			padding-bottom: 42px;
			font-size: 36px;
			
			font-weight: bold;
			color: #000000;
		}

		.societyAll {
			margin-bottom: 71px;
			display: flex;
			align-items: center;
			justify-content: space-between;

			.societyAllLeft {
				font-size: 24px;
				
				font-weight: 400;
				color: #000000;
			}

			.societyAllRight {
				font-size: 24px;
				
				font-weight: 300;
				color: #737373;
				display: flex;
				align-items: center;
			}
		}

		.societySs {
			background: rgba(239, 239, 239, 0);
			border: 2px solid #222222;
			border-radius: 10px;
			display: flex;
			height: 50px;
			margin-bottom: 31px;

			.societySsOne {
				flex: 1;
				height: 50px;
				padding-left: 30px;

				input {
					width: 100%;
					border: none;
					outline: none;
					background: none;
					height: 50px;
					font-size: 24px;
					
					font-weight: 300;
				}

				input::placeholder {
					color: #DFDFDF;
				}
			}

			.societySsTwo {
				border-radius:0  10px  10px 0;
				background: #343434;
				width: 212px;
				height: 50px;
				font-size: 24px;
				
				font-weight: 500;
				color: #FFFFFF;
				display: flex;
				align-items: center;
				justify-content: center;
				margin-right: -2px;
			}
		}

		.societyXl {
			display: flex;
			margin-bottom: 88px;

			.societyXlOne {
				margin-right: 15px;
			}
		}

		.societyList {
			padding-top: 73px;
			border-top: 2px solid #E5E5E5;

			.societyListFor {
				background: rgba(239, 239, 239, 0);
				border: 2px solid #E5E5E5;
				border-radius: 10px;
				margin-bottom: 30px;
				padding: 30px 38px;
				cursor: pointer;
				.societyListForTop{
					display: flex;
					.societyListForTopOne{
						flex: 1;
					}
					.societyListForTopTwo{
						font-size: 24px;
						color: #CCCCCC;
					}
				}
				.societyListForOne {
					font-size: 24px;
					
					font-weight: bold;
					color: #000000;
					margin-bottom: 13px;
					display: flex;
					.jiBox{
						width: 20px;
						position: relative;
						margin-right: 8px;
						.ji{
							background-color: #ff6b6b;
							width: 20px;
							height: 20px;
							font-size: 12px;
							line-height: 20px;
							border-radius: 4px;
							color: #fff;
							position: absolute;
							top: 6px;
							display: inline-block;
							text-align: center;
						}
					}
				}

				.societyListForTwo {
					font-size: 18px;
					
					font-weight: 300;
					color: #666666;
				}
				.societyListForThree{
					display: flex;
					align-items: center;
					margin-top: 33px;
					.societyListForThreeOne{
						font-size: 14px;
						
						font-weight: 400;
						color: #A7A7A7;
						flex: 1;
						word-wrap: break-word;
						word-break: break-all;
						overflow : hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-line-clamp: 3;
						// 必须加不然隐藏不了
						/*! autoprefixer: ignore next */
						-webkit-box-orient: vertical;

					}
					.societyListForThreeTwo{
						display: flex;
						align-items: flex-end;
						width: 200px;
						justify-content: center;
						>div{
							width: 107px;
							height: 47px;
							background-color: #1a2588;
							font-size: 24px;
							
							font-weight: 500;
							color: #FFFFFF;
							border-radius: 20px;
							display: flex;
							align-items: center;
							justify-content: center;
						}
						
					}
				}
			}
		}
		.societyTilTwo{
			font-size: 36px;
			
			font-weight: bold;
			color: #000000;
			margin-bottom: 40px;
			
		}
		.societyTilTwoCen{
			font-size: 24px;
			
			font-weight: 500;
			color: #B3B3B3;
			padding-bottom: 192px;
		}
	}


	@media screen and (max-width:1200px){
		.society{
			// background-color: red !important;
			.societyTil{
				font-size: 28px !important;
			}
			.societyList{
				.societyListFor{
					.societyListForThree{
						.societyListForThreeTwo{
							margin-left: 10px !important;
							width: auto !important;
							div{
								font-size: 18px !important;
								height: 40px !important;
								width: 100px !important;
								line-height: 40px !important;
							}
						}
					}
				}
			}
		}
	}



</style>
<style lang="scss">
	.el-pagination{
		display: flex;
	}
	.el-pager .number{
		width: 25px !important;
		height: 25px !important;
		line-height: 25px;
		min-width: 0;
	}
	.el-pager .active{
		color: #fff !important;
		background: #848484 !important;
		border-radius: 100%;
		
	}
</style>